import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { patientApi, patientErr } from "@/lib/patientApi";
import { AudioPlayer } from "@/components/AudioPlayer";
import { Heart, ArrowLeft, MusicNotes, PlayCircle, ClockCounterClockwise } from "@phosphor-icons/react";

const mmss = (s) => { s = Math.floor(s || 0); return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`; };

export default function KoleksiSaya() {
  const nav = useNavigate();
  const [items, setItems] = useState(undefined);
  const [active, setActive] = useState(null);

  const load = () => patientApi.get("/patient/collection").then((r) => setItems(r.data.items))
    .catch((e) => { if (e?.response?.status === 401) { localStorage.removeItem("patient_token"); nav("/pasien/masuk"); } else { setItems([]); toast.error(patientErr(e)); } });

  useEffect(() => {
    document.title = "Koleksi Relaksasi Saya — HalloGBS";
    if (!localStorage.getItem("patient_token")) { nav("/pasien/masuk"); return; }
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nav]);

  const closePlayer = () => { setActive(null); load(); };

  return (
    <div className="min-h-screen bg-[#FAF7FF]" data-testid="koleksi-saya">
      <header className="border-b border-rose-100 bg-white/90 backdrop-blur">
        <div className="mx-auto flex max-w-md items-center justify-between px-4 py-3">
          <a href="/akun-saya" className="flex items-center gap-1.5 text-sm font-bold text-[#7C4DE0]"><ArrowLeft size={16} weight="bold" /> Akun</a>
          <span className="flex items-center gap-1.5 font-heading text-base font-extrabold text-[#4C1D95]"><Heart size={18} weight="fill" className="text-[#DB2777]" /> HalloGBS</span>
        </div>
      </header>

      <main className="mx-auto max-w-md space-y-4 px-4 py-6">
        <div>
          <h1 className="flex items-center gap-2 font-heading text-2xl font-extrabold text-[#4C1D95]"><MusicNotes size={24} weight="duotone" className="text-[#DB2777]" /> Koleksi Relaksasi Saya</h1>
          <p className="mt-1 text-sm text-slate-500">Audio yang bisa Anda dengarkan penuh. Posisi putar tersimpan otomatis.</p>
        </div>

        {items === undefined && <p className="py-10 text-center text-sm text-slate-400">Memuat…</p>}

        {items && items.length === 0 && (
          <div data-testid="koleksi-empty" className="rounded-3xl border border-dashed border-pink-200 bg-white/60 py-12 text-center">
            <MusicNotes size={40} weight="duotone" className="mx-auto text-pink-200" />
            <p className="mt-3 px-6 text-sm text-slate-500">Belum ada audio di koleksi Anda. Jelajahi katalog atau hubungi Admin GBS untuk mendapatkan akses.</p>
            <a href="/relaksasi" data-testid="koleksi-browse" className="mt-4 inline-block rounded-xl bg-[#7C4DE0] px-4 py-2 text-sm font-bold text-white">Lihat Katalog Relaksasi</a>
          </div>
        )}

        {items && items.map((it) => (
          <button key={it.product_id} data-testid={`koleksi-item-${it.product_id}`} onClick={() => setActive(it)}
            className="flex w-full items-center gap-3 rounded-2xl border border-pink-100 bg-white p-3 text-left transition-transform hover:-translate-y-0.5">
            <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-[#EEE6FF] to-[#FDE7F1]">
              {it.has_cover ? null : <MusicNotes size={26} weight="duotone" className="text-[#7C4DE0]" />}
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-[11px] font-bold uppercase tracking-wide text-[#DB2777]">{it.category_label || it.category}</span>
              <span className="block truncate font-heading text-base font-extrabold text-[#1E1B4B]">{it.title}</span>
              <span className="mt-0.5 flex items-center gap-2 text-xs text-slate-500">
                {it.duration_sec ? <span>~{Math.round(it.duration_sec / 60)} mnt</span> : null}
                {it.position_sec > 0 && <span className="inline-flex items-center gap-1 text-emerald-600"><ClockCounterClockwise size={12} weight="bold" /> Lanjut {mmss(it.position_sec)}</span>}
              </span>
            </span>
            <PlayCircle size={34} weight="fill" className="shrink-0 text-[#7C4DE0]" />
          </button>
        ))}
      </main>

      {active && <AudioPlayer item={active} onClose={closePlayer} />}
    </div>
  );
}
